import BreadCrumbs from "./BreadCrumbs";
import { CreateNewStack } from "../../state/stackAtoms";
import NewStoryButton from "../controls/NewStoryButton";
import { Orientation } from "../../state/uiAtoms";
import { StyledTitle, text } from "@quickpoint.me/shared";
import ToggleStacksPanelButton from "../controls/ToggleStacksPanel";
import styled from "styled-components";
import { useRecoilValue } from "recoil";

const StyledControls = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    /* 8px between related buttons (spacing lives on the container, not the pills) */
    column-gap: 0.5rem;
`;

const StyledMessage = styled.span`
color: ${(props) => props.theme.navigationText};
  `;

export function StacksHeader() {
	const isInLandscape = useRecoilValue(Orientation) === "landscape";
	const createNewStack = useRecoilValue(CreateNewStack);

	if (!isInLandscape) {
		return (
			<StyledTitle $isInPortrait={!isInLandscape} className="title">
				<BreadCrumbs />
				<StyledControls className="story-modal--controls">
					{!createNewStack && <NewStoryButton />}
					<ToggleStacksPanelButton />
				</StyledControls>
			</StyledTitle>
		);
	}

	return (
		<>
			<StyledTitle $isInPortrait={!isInLandscape} className="title">
				<BreadCrumbs />
				<StyledMessage>{text.stacks.openOrCreate}</StyledMessage>
				<StyledControls className="story-modal--controls">
					{!createNewStack && <NewStoryButton />}
					<ToggleStacksPanelButton />
				</StyledControls>
			</StyledTitle>
		</>
	);
}
